import { render, staticRenderFns } from "./tipoagendamento.vue?vue&type=template&id=629aa27f&"
import script from "./tipoagendamento.vue?vue&type=script&lang=js&"
export * from "./tipoagendamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports